import React, { useEffect, useMemo, useState } from 'react';
import { Typography, Button, Alert } from 'antd';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Loading from 'components/Loading';
import { orderCollectionSpots, isSpotFromSources } from 'utils/collection-spot-utils';
import CollectionSpot from '../CollectionSpot';
import { useCollectionSpots } from 'api/collection-spots.api';
import './style.css';
import { parse } from 'utils/error-parser';

const { Text } = Typography;

const SortableItem = SortableElement(
    /**
     * @param {Object} props
     * @param {CollectionSpot} props.spot
     * @param {Source[]} props.filterBySources
     */
    ({ spot, filterBySources }) => (
        <CollectionSpot collectionSpot={spot} isDimmed={!isSpotFromSources(spot, filterBySources)} />
    )
);

const SortableList = SortableContainer(
    /**
     * @param {Object} props
     * @param {CollectionSpot[]} props.items
     * @param {Source[]} props.filterBySources
     */
    ({ items, filterBySources }) => {
        return (
            <div className='collection__content-spots'>
                {items.map((spot, index) => (
                    // @ts-ignore
                    <SortableItem key={`item-${spot.id}`} index={index} spot={spot} filterBySources={filterBySources} />
                ))}
            </div>
        );
    }
);

/**
 * @param {Object} props
 * @param {Collection} props.collection
 * @param {Source[]} props.filterBySources
 */
function CollectionSpots({ collection, filterBySources }) {
    const {
        collectionSpots,
        isValidating,
        error: errorLoadingCollectionSpots,
        refresh: refreshCollectionSpots,
    } = useCollectionSpots(collection.id);

    const isLoadingCollectionSpots = !collectionSpots && isValidating;

    const orderedSpots = useMemo(() => orderCollectionSpots(collectionSpots), [collectionSpots]);

    const [spotsToShow, setSpotsToShow] = useState(orderedSpots);

    useEffect(() => {
        setSpotsToShow(orderedSpots);
    }, [orderedSpots]);

    if (isLoadingCollectionSpots) {
        return (
            <div className='collection__content-loading'>
                <Loading />
            </div>
        );
    }

    if (errorLoadingCollectionSpots) {
        return (
            <div className='column-center'>
                <Alert
                    message='Error loading spots for this collection'
                    description={parse(errorLoadingCollectionSpots)}
                    showIcon
                    type='error'
                />
                <div className='mt-sm'></div>
                <Button size='large' onClick={() => refreshCollectionSpots()}>
                    Try again
                </Button>
            </div>
        );
    }

    if (!spotsToShow?.length) {
        return (
            <div className='collection__content-spots-empty'>
                <Text type='secondary'>No spots yet</Text>
            </div>
        );
    }

    return (
        // @ts-ignore
        <SortableList
            items={spotsToShow}
            filterBySources={filterBySources}
            distance={Number.MAX_SAFE_INTEGER}
            axis='xy'
            helperClass='collection-spot__dragging'
            onSortEnd={() => undefined}
        />
    );
}

export default CollectionSpots;
